/**
 * Delegates an event to an ancenstor element, much like jQuery `live` events.
 *
 * @param {HTMLElement} element - The element to which the delegated event listener is attached.
 * @param {string} event - The event name to listen for.
 * @param {string} descendentSelector - The CSS selector of the element(s) the event should be caught on.
 * @param {Function} callback - The function to be called when the event is triggered.
 */
export default function delegate(element, event, descendentSelector, callback) {
  element.addEventListener(event, e => {
    const currentTarget = e.target.closest(descendentSelector);
    if (currentTarget) {
      e.delegatedTarget = currentTarget;
      callback(e);
    }
  }, false);
}